import { Box, Typography } from "@mui/material";
import InAppRichTextEditor from "./InAppRichTextEditor";

const inAppNotificationHtmlContentSx = {
  fontSize: "14px",
  lineHeight: 1.5,
  "& b, & strong": { fontWeight: 700 },
  "& i, & em": { fontStyle: "italic" },
  "& mark": { backgroundColor: "#ffeb3b", padding: "0 2px" },
  "& ins": { textDecoration: "underline" },
  "& del": { textDecoration: "line-through" },
  "& u": { textDecoration: "underline" },
  "& small": { fontSize: "0.875em" },
  "& span[style*='font-size:small']": { fontSize: "0.875em" },
  "& span[style*='font-size:medium']": { fontSize: "1em" },
  "& span[style*='font-size:large']": { fontSize: "1.125em" },
  "& sup": { verticalAlign: "super", fontSize: "0.75em" },
  "& sub": { verticalAlign: "sub", fontSize: "0.75em" },
};

const WysiwygEditorField = ({
  label,
  value,
  onChange,
  error,
  height = 150,
  required = false,
  hideLabel = false,
  readOnly = false,
  maxLength,
  helperText,
  helperTone = "default",
}) => (
  <Box sx={{ width: "100%", minWidth: 0 }}>
    {!hideLabel && label && (
      <Typography variant="body2" sx={{ fontWeight: 600, mb: 1, color: "text.primary" }}>
        {label}
        {required && (
          <Typography component="span" color="error.main" sx={{ ml: 0.25 }}>
            *
          </Typography>
        )}
      </Typography>
    )}
    {readOnly ? (
      <Box
        sx={{
          border: "1px solid rgba(0, 0, 0, 0.23)",
          borderRadius: 1.5,
          bgcolor: "action.hover",
          p: 1.5,
          minHeight: height - 40,
          ...inAppNotificationHtmlContentSx,
        }}
        dangerouslySetInnerHTML={{ __html: value || "—" }}
      />
    ) : (
      <Box
        sx={{
          border: "1px solid rgba(0, 0, 0, 0.23)",
          borderRadius: 1.5,
          overflow: "visible",
          bgcolor: "#fff",
          ...inAppNotificationHtmlContentSx,
        }}
      >
        <InAppRichTextEditor
          value={value}
          onChange={onChange}
          height={height}
          placeholder="Enter description"
        />
      </Box>
    )}
    {!readOnly && (helperText || maxLength) && (
      <Typography
        variant="caption"
        color={
          helperTone === "error" || error
            ? "error.main"
            : "text.secondary"
        }
        sx={{ mt: 0.5, display: "block" }}
      >
        {helperText || `max ${maxLength} characters`}
      </Typography>
    )}
    {error && !hideLabel && (
      <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
        {error}
      </Typography>
    )}
  </Box>
);

export default WysiwygEditorField;
